import script from "./ModalDisplay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalDisplay.vue?vue&type=script&setup=true&lang=ts"

import "./ModalDisplay.vue?vue&type=style&index=0&id=5819e855&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5819e855"]])

export default __exports__